module.exports = __webpack_public_path__ + "static/media/topicPie.7bfe8912.png";